import { IRoomAmenities } from "./roomType";

export enum ERoomUnit {
  SQUARE_METERS = "square_meters",
}

export enum EAvailableRoom {
  AVAILABLE = "available",
  UNAVAILABLE = "unavailable",
}

export enum ERoomFacilities {
  WIFI = "yes_free",
}

export enum ERoomType {
  PLAN = "plan",
  ROOMS = "rooms",
  RECOMMENDATION = "recommendation",
  ROOM = "room",
  PLANTS = "plants",
}

export enum ERoomSearchType {
  UNDATED = "undated",
}

export enum ERoomOrderBy {
  PRICE_LOW_TO_HIGH = "price_low_to_high",
  PRICE_HIGH_TO_LOW = "price_high_to_low ",
  RECOMMENDED = "recommended",
  JAPAN_CURRENCY = "JPY",
}

export enum ERoomMode {
  STANDARD = "standard",
  VOUCHER = "voucher",
  SECRET = "secret",
}

export enum EEINCLUSIVE_SALES_TYPE {
  PER_ROOM_PER_NIGH = "per_room_per_night",
  PER_HEADCOUNT_PER_NIGHT = "per_headcount_per_night",
  PER_ROOM = "per_room",
  PER_HEADCOUNT = "per_headcount",
}

export interface IRoomReq {
  adults: string;
  children: number;
  kids_age_range?: KidsAgeRange[];
  is_smoking?: boolean;
}

export interface KidsAgeRange {
  code: string;
  count: number;
}

export interface IRoomListRequest {
  hotel_id: string;
  rooms: IRoomReq[];
  type?: ERoomType;
  adults?: string;
  children?: number;
  checkin_date: string;
  checkout_date: string;
  //Set undated if you do not want to specify the checkin, checkout date. When type is recommendation, this must be undated
  search_type?: ERoomSearchType;
  //Give when search_type undated.0 is for day use.
  nights?: number;
  adult_companion?: number;
  kid_tier_A_companion?: number;
  room_search_filters?: string;
  order?: ERoomOrderBy; //Defaults to price_low_to_high
  is_day_use?: boolean;
  is_including_occupied?: boolean;
  bookable?: boolean;
  mode?: ERoomMode;
  room_plan_codes?: string[];
  hotel_plan_codes?: string[];
  room_type_codes?: string[];
  dynamic_package?: string;

  authorization?: string;
}

export interface IRoomListResponse {
  data: IRoomListData;
}

export interface IRoomListData {
  rooms: IRoom[];
  mcp_currency: string;
  search_params: ISearchParams;
  extra_inventories: IExtraInventories[];
  payment_promotion_info: IPaymentPromotionInfo;
}

export interface IRoomAmenitiesAndFacilities {
  order: number;
  documentId: string;
  amenityService: {
    item_name: string;
    room_icon: string | null;
    title: string | null;
    documentId: string;
  };
  iconData: {
    item_name: string;
    documentId: string;
    properties: {
      css_class: string | null;
    } | null;
  };
}

export interface IRoom {
  id: string;
  documentId?: string;
  min_price?: number;
  room_count?: number;
  room_pictures: IRoomPicture[];
  room_plan?: IRoomPlan[];
  room_type_name: string;
  room_type_code: string;
  room_type_description: string;
  min_people?: string;
  max_people?: string;
  max_adult?: number;
  hide_smoking?: boolean;
  room_facilities?: Record<string, string | number | boolean | null>;
  position?: number;
  filters: IFilter[];
  beds: IBed[];
  floor_data: string;
  room_size: IRoomSize;
  mcp_min_price?: {
    cents: number;
    currency_iso: string;
  };
  description: string | undefined;
  additional_description?: string | null;
  custom_bed_count?: string | null;
  facilities_and_amenities?: {
    order: number;
    documentId: string;
  }[];
  facilities_amenities_icon?: IRoomAmenitiesAndFacilities[];
  room_amenities?: IRoomAmenities[];
  amenities_popup_label?: string | null;
}

export interface IRoomPicture {
  display_name: string;
  id: string;
  picture: IPicture;
}

export interface IPicture {
  url: string;
  chatbot_header?: IChatbotHeader;
  thumbnail: IThumbnail;
  wordpress?: IWordpress;
  alt_text?: string;
  caption?: string;
}

export interface IChatbotHeader {
  url: string;
}

export interface IThumbnail {
  url: string;
}

export interface IWordpress {
  url: string;
}

export interface IRoomPlan {
  availability: string;
  booking_start_date: Date;
  hotel_plan_code: string;
  position: number;
  limited: boolean;
  hotel_plan_description: string;
  total_price: number;
  only_visible_to_guest: boolean;
  charge_percent: number;
  tax: number;
  room_rate: IRoomRate[];
  url_plan_pictures: string[];
  sleeps: number;
  selected_room_count: number;
  cancellation_policy_link: string;
  cancellation_policy_id: number;
  filters: IFilter[];
  matched_search_criteria: IMatchedSearchCriteria;
  cancellation_free_deadline: string;
  is_no_refund: boolean;
  meal_status: string;
  payment_method: IPaymentMethod[];
  room_plan_code: string;
  room_plan_name: string;
  wifi_option: string;
  non_sign_in_discount: INonSignInDiscount;
  wifi: string;
  sign_in_discount: ISignInDiscount;
}

export interface IRoomRate {
  date: string;
  rate: number;
}

export interface IMatchedSearchCriteria {
  adults_count: number;
  children_count: number;
}

export interface IPaymentMethod {
  code: string;
  name: string;
}
type NullableId = string | number | null;
export interface INonSignInDiscount {
  total_price_after_discount: number;
  total_price_after_discount_tax: number;
  applied_scrape_id: NullableId;
  brr_prices: IBrrPrice[];
  promotions: IPromotion[];
}

export interface IBrrPrice {
  ota: string;
  ota_name: string;
  ota_price: string;
  ota_price_value: number | string;
  scrape_id: NullableId;
  scrape_room_plan_id: NullableId;
  service_fee: string;
}

export interface ISignInDiscount {
  total_price_after_discount: number;
  total_price_after_discount_tax: number;
  applied_scrape_id: number;
  brr_prices: IBrrPrice2[];
  promotions: IPromotion[];
}

export interface IBrrPrice2 {
  ota: string;
  ota_name: string;
  ota_price: string;
  ota_price_value: number | string;
  scrape_id: string | number | null;
  scrape_room_plan_id: string | number | null;
  service_fee: string;
}

export interface IPromotion {
  id: number;
  name: string;
  promotion_type: string;
  coupon_code: string;
  sale_start_date: Date;
  sale_end_date: Date;
  excluding_start_date: Date;
  excluding_end_date: Date;
  discount_amount: number;
  discount_amount_without_tax: number;
}

export interface IFilter {
  id: number;
  name: string;
  filter_type: string;
  order: number;
}

export interface IBed {
  bed_count: number;
  width: string;
  length: string;
  bed_type: string;
}

export interface IRoomSize {
  value: string;
  unit: string;
}

export interface ISearchParams {
  room_types: HotelPlan[];
  hotel_plans: HotelPlan[];
}

export interface HotelPlan {
  code: string;
  name: string;
}

interface IExtraInventories {
  extra_id: number;
  inventory: number;
  inclusive_sales_type: EEINCLUSIVE_SALES_TYPE;
}
interface IPaymentPromotionInfo {
  uuid: string;
  payment_type: string;
  target_mode: string;
  target_type: string;
  hotel_plan_codes: string[];
  discount_amount: number;
}

interface Room {
  checkin_date: string;
  checkout_date: string;
  adults: string;
  children: string;
  kids_age_range: string[];
}

export interface HotelListParams {
  brandId: number;
  page?: number;
  per_page?: number;
  rooms: Room[];
  hotel_codes: string[];
  is_including_lowest_price?: boolean;
  is_including_max_of_lowest_price_next_30_days?: boolean;
}

export interface LowestPriceHotelsResponse {
  data: LowestPriceHotels[];
  page: number;
  total_pages: number;
  total_entries: number;
}
export interface LowestPriceHotels {
  id: number;
  name: string;
  tel: string;
  latitude: string;
  longitude: string;
  triplabot_code: string;
  is_demo: boolean;
  triplabot_url: string;
  is_booking_widget_active: boolean;
  lowest_price: number;
  address: Address;
}

export interface Address {
  full_address: string;
  city: string;
  state: string;
  post_code: string;
  country: string;
  country_code: string;
}
